import axios from './configObra/config-obra'

const defaultRoute = '/equipments'

export default {
  loadEquipmentsByPagination: async ({ filial, page, limit }) => {
    if (filial) {
      const { data } = await axios.get(`${defaultRoute}/pagination`, {
        params: { filial, page, limit },
      })

      return data
    }

    const { data } = await axios.get(`${defaultRoute}/pagination`, {
      params: { page, limit },
    })

    return data
  },

  loadEquipmentsAvailable: async ({ filial }) => {
    if (filial) {
      const { data } = await axios.get(`${defaultRoute}/available`, {
        params: { filial },
      })

      return data
    }

    const { data } = await axios.get(`${defaultRoute}/available`)

    return data
  },
  create: async (equipment) => {
    const { data } = await axios.post(defaultRoute, equipment)

    return data
  },
  update: async ({ _id, equipment }) => {
    const { data } = await axios.patch(`${defaultRoute}/${_id}`, equipment)

    return data
  },
  remove: async (id) => {
    const { data } = await axios.delete(`${defaultRoute}/${id}`)

    return data
  },
  requestEquipment: async (requisition) => {
    const { data } = await axios.post(`requisicoes/equipament`, requisition)

    return data
  },
  getRequestsEquipments: async (filial) => {
    let data = []
    if (filial) {
      data = await axios.get(`requisicoes/equipments?filial=${filial}`)
    } else {
      data = await axios.get(`requisicoes/equipments`)
    }

    return data.data
  },
  deliveryEquipment: async (payload, idEquipment) => {
    const data = await axios.post(
      `/equipments/${idEquipment}/equipment-delivered/`,
      payload
    )

    return data
  },
  deleteDeliveryEquipment: async (id) => {
    const data = await axios.delete(`/equipments/${id}/equipment-delivered/`)

    return data
  },

  getByInsumo: async (id) => {
    const data = await axios.get(`${defaultRoute}/find-insumo/${id}`)

    return data
  },

  loadIdleEquipments: async ({ filial }) => {
    if (filial) {
      const data = await axios.get(`${defaultRoute}/idle-equipments`, {
        params: { filial },
      })

      return data
    } else {
      const data = await axios.get(`${defaultRoute}/idle-equipments`)

      return data
    }
  },

  loadEquipmentsNecessaries: async ({ filial }) => {
    if (filial) {
      const data = await axios.get(`${defaultRoute}/equipments-necessaries`, {
        params: { filial },
      })

      return data
    }

    const data = await axios.get(`${defaultRoute}/equipments-necessaries`)

    return data
  },

  createEquipmentNecessary: async (payload) => {
    const data = await axios.post(
      `${defaultRoute}/equipments-necessaries`,
      payload
    )

    return data
  },

  generateEquipmentReport: async (typeReport) => {
    const { data } = await axios.get(`${defaultRoute}/report`, {
      params: {
        typeReport: typeReport,
      },
      responseType: 'blob',
    });
  
    return data;
  }
}
